/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";

import { ApiUrls } from "../../services/api";
import Api from "../../services/api/serviceCall";
import { Constants } from "../../config/appConstants";
import * as actions from "../../actions/device.Action";
import SplashScreenComponent from "./splashScreen.Component";
import { MessageBox } from "../sharedComponent/messageBox";

/* Package JSON Import will be here */
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class SplashScreen extends Component {
  componentDidMount() {
    this.handleSession();
  }

  handleSession = () => {
    try {

      const deviceUniqueGuid = window.localStorage.getItem('deviceUniqueGuid')??"";      
     
            let url = ApiUrls.Routes.DEVCE_C + ApiUrls.Routes.IS_DEVCE_ALRDY_REGD;
            Api.Post(url, deviceUniqueGuid, this).then(
                (responseData) => {
                    if (responseData.success) {
                        this.props.deviceRegistrationSuccess(
                            responseData.data.isDeviceAlreadyRegistered,
                            responseData.data.deviceFingerPrintId,
                            responseData.data.deviceId
                        );

                        if (responseData.data.isDeviceAlreadyRegistered) {
                            this.props.history.push("/Login");
                        } else {
                            this.props.history.push("/Register");
                        }
                    } else {
                        MessageBox(responseData.message, Constants.ERROR);
                    }
                }
            );        
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    return <SplashScreenComponent />;
  }
}

function mapStateToProps(state) {
  return {
    user: state.loginReducer.user,
    device: state.deviceReducer.device
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, actions), dispatch);
}

SplashScreen.displayName = "SplashScreen";

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SplashScreen)
);